import { FC, useCallback, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Megaphone } from 'lucide-react'
import { useAuth } from '@store/auth/AuthProvider'
import { fetchFromApi } from '@utils/apiOrigin'
import { CAMBIOS_REFRESH_EVENT, getCambioAuthHeaders } from '@utils/cambiosLabels'

const POLL_MS = 60 * 1000

export const ChangesBell: FC = () => {
  const { isAuthenticated } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const [count, setCount] = useState(0)

  const refresh = useCallback(async () => {
    if (!isAuthenticated) return
    try {
      const response = await fetchFromApi('/api/cambios/unread-count', {
        headers: getCambioAuthHeaders()
      })
      if (!response.ok) return
      const { data } = await response.json()
      setCount(data.count || 0)
    } catch {
      return
    }
  }, [isAuthenticated])

  useEffect(() => {
    void refresh()
    const timer = setInterval(() => void refresh(), POLL_MS)
    const handleRefresh = () => void refresh()
    window.addEventListener(CAMBIOS_REFRESH_EVENT, handleRefresh)
    return () => {
      clearInterval(timer)
      window.removeEventListener(CAMBIOS_REFRESH_EVENT, handleRefresh)
    }
  }, [refresh])

  useEffect(() => {
    void refresh()
  }, [location.pathname, refresh])

  if (!isAuthenticated) return null

  return (
    <button
      type="button"
      onClick={() => navigate('/cambios')}
      className="relative p-2 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-gray-900 transition-colors"
      aria-label={count > 0 ? `Cambios: ${count} novedades sin leer` : 'Cambios'}
      title="Historial de cambios"
    >
      <Megaphone className="h-5 w-5" />
      {count > 0 && (
        <span className="absolute -top-0.5 -right-0.5 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold">
          {count > 99 ? '99+' : count}
        </span>
      )}
    </button>
  )
}
